module.exports = __webpack_public_path__ + "img/Look-For-A-Quiet-Spot.5b96df21.jpg";